var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 898,
    height: 471,
    viewBox: "0 0 898 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.449 239.04L376.291 270.658L505.732 195.562L448.916 163.943L321.449 239.04Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.449 406.024L376.291 437.643L505.732 362.552L448.916 330.934L321.449 406.024Z",
    stroke: "#231F20",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M321.762 406.024L376.603 437.643L506.039 362.552L449.229 330.934L321.762 406.024Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376.293 270.658V437.642",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M448.422 163.943V330.933L505.676 362.493V195.509",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.449 238.49V405.474",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321.449 328.764L376.291 360.382L505.732 285.285L448.916 253.667L321.449 328.764Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M321.762 406.024L376.603 437.643L506.039 362.552L449.229 330.934L321.762 406.024Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.293 360.382V437.648",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M321.449 328.214V407.479",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M375.594 360.478L430.435 392.096L559.877 316.999L503.061 285.381L375.594 360.478Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375.906 437.738L430.748 469.357L560.183 394.266L503.373 362.647L375.906 437.738Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M430.438 392.096V469.356",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M558.832 316.296V393.556",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M375.594 359.928V439.192",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.89 237.551L202.055 269.175L72.6133 194.078L129.429 162.46L256.89 237.551Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M256.89 404.541L202.055 436.159L72.6133 361.063L129.429 329.444L256.89 404.541Z",
    stroke: "#231F20",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.584 404.541L201.742 436.159L72.3008 361.063L129.117 329.444L256.584 404.541Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M202.055 269.175V436.159",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.922 162.46V329.444L72.668 361.009V194.025",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256.891 237.007V403.991",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "4.28 4.28"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2 238.266L56.8415 269.884L186.283 194.787L129.467 163.169L2 238.266Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2 405.25L56.8415 436.874L186.283 361.778L129.467 330.159L2 405.25Z",
    stroke: "#231F20",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3125 405.25L57.154 436.874L186.59 361.778L129.779 330.159L2.3125 405.25Z",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8438 269.884V436.874",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.973 163.169V330.159L186.226 361.724V194.734",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2 237.716V404.706",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M649.379 0.745117V425.378",
    stroke: "white",
    strokeWidth: 1.23565,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M698.547 0V425.378",
    stroke: "white",
    strokeWidth: 1.23565,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M746.227 0V425.378",
    stroke: "white",
    strokeWidth: 1.23407,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M790.926 0V425.378",
    stroke: "white",
    strokeWidth: 1.23673,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M838.602 0.745117V425.378",
    stroke: "white",
    strokeWidth: 1.23565,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M883.301 0V425.378",
    stroke: "white",
    strokeWidth: 1.23565,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M649.823 388.336C657.343 388.336 663.439 382.24 663.439 374.72C663.439 367.201 657.343 361.104 649.823 361.104C642.303 361.104 636.207 367.201 636.207 374.72C636.207 382.24 642.303 388.336 649.823 388.336Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M697.776 339.608C705.296 339.608 711.392 333.512 711.392 325.992C711.392 318.472 705.296 312.376 697.776 312.376C690.256 312.376 684.16 318.472 684.16 325.992C684.16 333.512 690.256 339.608 697.776 339.608Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M745.737 208.114C753.257 208.114 759.353 202.018 759.353 194.499C759.353 186.979 753.257 180.883 745.737 180.883C738.217 180.883 732.121 186.979 732.121 194.499C732.121 202.018 738.217 208.114 745.737 208.114Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M838.553 259.159C846.073 259.159 852.169 253.063 852.169 245.544C852.169 238.024 846.073 231.928 838.553 231.928C831.034 231.928 824.938 238.024 824.938 245.544C824.938 253.063 831.034 259.159 838.553 259.159Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M789.823 235.96C797.343 235.96 803.439 229.864 803.439 222.344C803.439 214.825 797.343 208.729 789.823 208.729C782.303 208.729 776.207 214.825 776.207 222.344C776.207 229.864 782.303 235.96 789.823 235.96Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M883.413 326.452C890.932 326.452 897.028 320.356 897.028 312.836C897.028 305.317 890.932 299.221 883.413 299.221C875.893 299.221 869.797 305.317 869.797 312.836C869.797 320.356 875.893 326.452 883.413 326.452Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M649.824 374.719L697.778 325.991L745.738 194.498L838.937 249.416L883.415 312.836",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M649.824 249.416L697.778 200.682L744.573 135.322L838.937 165.492L883.415 187.533",
    stroke: "white",
    strokeWidth: 1.54899,
    strokeMiterlimit: 10,
    strokeDasharray: "3.55 3.55"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M649.823 263.032C657.343 263.032 663.439 256.936 663.439 249.417C663.439 241.897 657.343 235.801 649.823 235.801C642.303 235.801 636.207 241.897 636.207 249.417C636.207 256.936 642.303 263.032 649.823 263.032Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.774497,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M697.776 214.299C705.296 214.299 711.392 208.203 711.392 200.683C711.392 193.163 705.296 187.067 697.776 187.067C690.256 187.067 684.16 193.163 684.16 200.683C684.16 208.203 690.256 214.299 697.776 214.299Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.774497,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M744.573 148.939C752.093 148.939 758.189 142.843 758.189 135.323C758.189 127.803 752.093 121.707 744.573 121.707C737.053 121.707 730.957 127.803 730.957 135.323C730.957 142.843 737.053 148.939 744.573 148.939Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.774497,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M838.936 179.109C846.456 179.109 852.552 173.013 852.552 165.493C852.552 157.973 846.456 151.877 838.936 151.877C831.416 151.877 825.32 157.973 825.32 165.493C825.32 173.013 831.416 179.109 838.936 179.109Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.774497,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M789.432 165.185C796.952 165.185 803.048 159.089 803.048 151.569C803.048 144.049 796.952 137.953 789.432 137.953C781.912 137.953 775.816 144.049 775.816 151.569C775.816 159.089 781.912 165.185 789.432 165.185Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.774497,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M883.413 201.15C890.932 201.15 897.028 195.054 897.028 187.534C897.028 180.014 890.932 173.918 883.413 173.918C875.893 173.918 869.797 180.014 869.797 187.534C869.797 195.054 875.893 201.15 883.413 201.15Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.774497,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.2f7d85a1babbcc027b47aaafafc2b783.svg";
export { ForwardRef as ReactComponent };